var _defs, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC40LogoCorrect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.01,
    y: -0.35,
    width: 1080,
    height: 1080
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.55,
    y: 41.19,
    width: 996.92,
    height: 996.92
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.17,415.84v-.72c0-69.55,52.07-126.5,126.16-126.5,45.08,0,72.34,15.72,95.75,38.1l-27.6,31.78c-19.59-18.18-40.57-30.39-68.5-30.39-46.83,0-80.7,38.42-80.7,86.29v.71c0,47.89,33.87,87.02,80.7,87.02,30.06,0,49.3-12.23,70.27-31.78l27.6,27.95c-25.53,26.56-53.48,43.35-99.27,43.35-71.29,0-124.41-55.56-124.41-125.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.44,447.27v-96.77l-80.36,96.77h80.36ZM545.44,482.57h-123.32l-8.06-30.75,135.92-160.75h36.7v156.2h34.94v35.3h-34.94v54.89h-41.24v-54.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M870.79,415.84v-.72c0-47.49-34.58-87-83.19-87s-82.45,38.76-82.45,86.29v.71c0,47.53,34.57,87.02,83.14,87.02s82.51-38.78,82.51-86.29M660.02,415.84v-.72c0-68.84,53.18-126.5,128.26-126.5s127.57,56.95,127.57,125.79v.71c0,68.88-53.06,126.54-128.25,126.54s-127.58-56.96-127.58-125.81"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.17,706.52v-.42c0-46.59,34.82-84.65,84.39-84.65,30.15,0,48.34,10.49,64.08,25.48l-18.47,21.29c-13.13-12.18-27.14-20.37-45.85-20.37-31.35,0-54,25.71-54,57.73v.52c0,32,22.65,58.19,54,58.19,20.09,0,32.95-8.18,46.97-21.3l18.47,18.69c-17.04,17.8-35.78,28.99-66.38,28.99-47.67,0-83.21-37.17-83.21-84.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 345.57,
    y: 624.24,
    width: 28.71,
    height: 163.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "458.2 650.9 406.32 650.9 406.32 624.26 539.08 624.26 539.08 650.9 487.2 650.9 487.2 787.89 458.2 787.89 458.2 650.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 571.1,
    y: 624.24,
    width: 28.74,
    height: 163.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "643.57 624.25 764.87 624.25 764.87 649.99 672.32 649.99 672.32 692.5 754.36 692.5 754.36 718.24 672.32 718.24 672.32 762.13 766.06 762.13 766.06 787.88 643.57 787.88 643.57 624.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M789.18,764.05l17.32-20.58c15.67,13.53,31.32,21.28,51.65,21.28,17.76,0,28.98-8.21,28.98-20.59v-.46c0-11.67-6.53-18.01-36.93-25.01-34.85-8.41-54.45-18.68-54.45-48.87v-.46c0-28.02,23.33-47.46,55.86-47.46,23.8,0,42.78,7.24,59.38,20.58l-15.43,21.74c-14.73-11-29.49-16.85-44.44-16.85-16.84,0-26.66,8.65-26.66,19.46v.42c0,12.63,7.52,18.25,38.84,25.72,34.58,8.41,52.55,20.81,52.55,47.88v.51c0,30.63-24.09,48.86-58.45,48.86-24.95,0-48.59-8.63-68.22-26.17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC40LogoCorrect);
export default __webpack_public_path__ + "static/media/c40_logo_correct.044aa6127bb5fa39fae277679aeb0dae.svg";
export { ForwardRef as ReactComponent };